import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import AppTextInput from '../../../../@jumbo/components/Common/formElements/AppTextInput';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import { useDropzone } from 'react-dropzone';
import Button from '@material-ui/core/Button';
import CmtList from '../../../../@coremat/CmtList';
import IconButton from '@material-ui/core/IconButton';
import AppSelectBox from '../../../../@jumbo/components/Common/formElements/AppSelectBox';
import { emailNotValid, requiredMessage } from '../../../../@jumbo/constants/ErrorMessages';
import { useDispatch, useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import { isValidEmail } from '../../../../@jumbo/utils/commonHelper';
import { addNewUser, updateUser } from '../../../../redux/actions/Fornitori';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { set } from 'lodash';

const useStyles = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));

function PhoneNumberInput({ onChange, value, ...other }) {
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    if (!phoneNumber && value) {
      setTimeout(() => {
        setPhoneNumber(value);
      }, 300);
    }
  }, [phoneNumber, value]);

  const onNumberChange = number => {
    setPhoneNumber(number.formattedValue);
    onChange(number.formattedValue);
  };

  return <NumberFormat {...other} onValueChange={onNumberChange} value={phoneNumber} />;
}

const ruoli = [
  { title: 'Admin', slug: '1' },
  { title: 'Utente', slug: '1' },
  { title: 'Altro', slug: '1' },
];

const labels = [
  { title: 'Casa', slug: 'casa' },
  { title: 'Ufficio', slug: 'ufficio' },
  { title: 'Cellulare', slug: 'cellulare' },
];

const splitName = user => {
  if (user) {
    console.log({ user });
    return [user.nome, user.cognome];
  }

  return ['', ''];
};

const AddEditUser = ({ open, onCloseDialog }) => {
  const classes = useStyles();
  const currentUser = useSelector(({ fornitoriReducer }) => fornitoriReducer.currentUser);

  const [uid, setUid] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [profile_pic, setProfile_pic] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [company, setCompany] = useState('');
  const [ruolo, setRuolo] = useState('2');
  const [phones, setPhones] = useState([{ phone: '', label: 'cellulare' }]);

  const [ragSocError, setRagSocError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  //campi fornitore aggiuntivi
  const [ragsoc, setRagsoc] = useState('');
  const [piva, setPiva] = useState('');
  const [codfiscale, setCodfiscale] = useState('');
  const [indirizzo, setIndirizzo] = useState('');
  const [localita, setLocalita] = useState('');
  const [prov, setProv] = useState('');
  const [cap, setCap] = useState('');
  const [referente, setReferente] = useState('');
  const [telefono, setTelefono] = useState('');

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: acceptedFiles => {
      setProfile_pic(URL.createObjectURL(acceptedFiles[0]));
    },
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUser) {
      const [fName, lName] = splitName(currentUser);
      setFirstName(fName);
      setLastName(lName);
      setUid(currentUser.uid);
      setProfile_pic(currentUser.profile_pic);
      setEmail(currentUser.email);
      setUsername(currentUser.username);
      setCompany(currentUser.company);
      setRuolo(currentUser.livello);
      //setPhones(currentUser.phones);
      setTelefono(currentUser.telefono);
      setRagsoc(currentUser.ragsoc);
      setPiva(currentUser.piva);
      setCodfiscale(currentUser.codfiscale);
      setIndirizzo(currentUser.indirizzo);
      setLocalita(currentUser.localita);
      setProv(currentUser.prov);
      setCap(currentUser.cap);
      setReferente(currentUser.referente);
    }
  }, [currentUser]);

  const onPhoneNoAdd = (number, index) => {
    const updatedList = [...phones];
    updatedList[index].phone = number;
    setPhones(updatedList);
    setPhoneError('');
  };

  const onPhoneRowRemove = index => {
    const updatedList = [...phones];
    updatedList.splice(index, 1);
    setPhones(updatedList);
  };

  const handleChange = valore => {
    const val = valore.target.value;
    setRuolo(val);
  };

  const onPhoneRowAdd = () => {
    setPhones(phones.concat({ phone: '', label: 'cellulare' }));
  };

  const onLabelChange = (value, index) => {
    const updatedList = [...phones];
    updatedList[index].label = value;
    setPhones(updatedList);
  };

  const onSubmitClick = () => {
    const phoneNumbers = phones.filter(item => item.phone.trim());
    if (!ragsoc) {
      setRagSocError(requiredMessage);
    } else {
      /* 
    else if (!email) {
      setEmailError(requiredMessage);
    } else if (!isValidEmail(email)) {
      setEmailError(emailNotValid);
    } else if (phoneNumbers.length === 0) {
      setPhoneError(requiredMessage);
    } 
    */
      onUserSave(phoneNumbers);
    }
  };

  const onUserSave = phoneNumbers => {
    const userDetail = {
      uid,
      profile_pic,
      nome: firstName,
      cognome: lastName,
      email,
      //phones: phoneNumbers,
      telefono: telefono,
      username,
      password,
      ruolo,
      company,
      //campi fornitore aggiuntivi
      ragsoc,
      piva,
      codfiscale,
      indirizzo,
      localita,
      prov,
      cap,
      referente,
    };

    const updatedUser = { ...currentUser, ...userDetail };
    console.log('il fornitore', updatedUser);

    if (currentUser) {
      dispatch(
        updateUser(updatedUser, () => {
          onCloseDialog();
        }),
      );
    } else {
      dispatch(
        addNewUser(userDetail, () => {
          onCloseDialog();
        }),
      );
    }
  };

  //const isPhonesMultiple = phones.length > 1;

  return (
    <Dialog disableBackdropClick open={open} onClose={onCloseDialog} className={classes.dialogRoot}>
      <DialogTitle className={classes.dialogTitleRoot}>
        {currentUser ? 'Modifica utente' : 'Crea un nuovo utente'}
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <Box {...getRootProps()} mr={{ xs: 0, md: 5 }} mb={{ xs: 3, md: 0 }} className="pointer">
            <input {...getInputProps()} />
            <CmtAvatar size={70} src={profile_pic} />
          </Box>
          <GridContainer>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Ragione sociale"
                value={ragsoc}
                onChange={e => {
                  setRagsoc(e.target.value);
                  setRagSocError('');
                }}
                helperText={ragSocError}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Partita IVA"
                value={piva}
                onChange={e => setPiva(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Codice fiscale"
                value={codfiscale}
                onChange={e => setCodfiscale(e.target.value)}
              />
            </Grid>
          </GridContainer>
        </Box>
        <Box mb={{ xs: 6, md: 5 }}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="Email Address"
            value={email}
            onChange={e => {
              setEmail(e.target.value);
              setEmailError('');
            }}
            helperText={emailError}
          />
        </Box>
        <GridContainer style={{ marginBottom: 2 }}>
          <Grid item xs={12} sm={6}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Telefono"
              value={telefono}
              onChange={e => setTelefono(e.target.value)}
              helperText={phoneError}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Referente"
              value={referente}
              onChange={e => setReferente(e.target.value)}
            />
          </Grid>
        </GridContainer>
        <Box mb={{ xs: 6, md: 5 }} display="inline-flex" alignItems="center" className="pointer" />
        <GridContainer style={{ marginBottom: 12 }}>
          <Grid item xs={indirizzo} sm={7}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Indirizzo"
              value={indirizzo}
              onChange={e => setIndirizzo(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Località"
              value={localita}
              onChange={e => setLocalita(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Provincia"
              value={prov}
              onChange={e => setProv(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <AppTextInput fullWidth variant="outlined" label="CAP" value={cap} onChange={e => setCap(e.target.value)} />
          </Grid>
        </GridContainer>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog}>Cancel</Button>
          <Box ml={2}>
            <Button variant="contained" color="primary" onClick={onSubmitClick}>
              Save
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddEditUser;

AddEditUser.prototype = {
  open: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func,
};
